module.exports = __webpack_public_path__ + "img/arrows-alt.1fcaa9b2.svg";